import { DateFilterOptionType } from 'models-date-filter';

import {
  getDateRangeBasedOnCreationDate,
  getDayBasedRange,
  getHourBasedRange,
  getMonthBasedRange,
} from './utc';

type DateRange = { from: string; to: string };

export function deductDateFilter(
  dateFilterOption: DateFilterOptionType,
  creationDate?: Date,
): DateRange {
  switch (dateFilterOption) {
    case DateFilterOptionType.Last6Hours:
      return getHourBasedRange(6);
    case DateFilterOptionType.Last12Hours:
      return getHourBasedRange(12);
    case DateFilterOptionType.Last24Hours:
      return getHourBasedRange(24);
    case DateFilterOptionType.Last2Days:
      return getDayBasedRange(2);
    case DateFilterOptionType.Last7Days:
      return getDayBasedRange(7);
    case DateFilterOptionType.Last2Weeks:
      return getDayBasedRange(14);
    case DateFilterOptionType.Last30Days:
      return getDayBasedRange(30);
    case DateFilterOptionType.Last90Days:
      return getDayBasedRange(90);
    case DateFilterOptionType.Last1Month:
      return getMonthBasedRange(1);
    case DateFilterOptionType.Last3Months:
      return getMonthBasedRange(3);
    case DateFilterOptionType.Last6Months:
      return getMonthBasedRange(6);
    case DateFilterOptionType.Last1Year:
      return getMonthBasedRange(12);
    case DateFilterOptionType.SinceInception:
      if (creationDate) {
        return getDateRangeBasedOnCreationDate(creationDate);
      }
      return getDayBasedRange(90);
    default:
      return dateFilterOption;
  }
}
